module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two-a_quote@2x.b45b9fdf.jpg";